import { render, staticRenderFns } from "./ClearDataSlide.vue?vue&type=template&id=b22079d0"
import script from "./ClearDataSlide.vue?vue&type=script&lang=js"
export * from "./ClearDataSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports